import React from 'react';
import { Section, SectionHeading, Reveal } from '../shared/Section';
type Row = {
  emoji: string;
  content: string;
  status: 'included' | 'gift';
};
const rows: Row[] = [{
  emoji: '🔥',
  content: 'Módulo 1 — Dolor Lumbar · Rutinas para descomprimir, aliviar y prevenir el dolor en la espalda baja',
  status: 'included'
}, {
  emoji: '⚡',
  content: 'Módulo 2 — Cervical y Cuello · Secuencias suaves para liberar tensión en cuello, trapecios y hombros',
  status: 'included'
}, {
  emoji: '🦵',
  content: 'Módulo 3 — Rodillas · Ejercicios de movilidad para proteger y fortalecer las rodillas de forma segura',
  status: 'included'
}, {
  emoji: '🧘',
  content: 'Módulo 4 — Estiramientos Diarios · Rutinas completas de 10 a 20 minutos para ganar flexibilidad',
  status: 'included'
}, {
  emoji: '🦶',
  content: 'Módulo 5 — Cadera y Tobillo · Movimientos para recuperar estabilidad, movilidad y libertad al caminar',
  status: 'included'
}, {
  emoji: '📈',
  content: 'Módulo 6 — Progreso Sostenible · Un plan simple para organizar tus prácticas y convertirlas en hábito',
  status: 'included'
}, {
  emoji: '🎁',
  content: 'Bono 1 — Guía de Estiramientos Completos por Tiempo · Secuencias claras para cada momento de tu día',
  status: 'gift'
}, {
  emoji: '🎁',
  content: 'Bono 2 — Rutina Anti-tensión para Cuello y Trapecios · Liberá tensión acumulada con una práctica suave',
  status: 'gift'
}, {
  emoji: '🎁',
  content: 'Bono 3 — Checklist de Progreso Semana a Semana · Registrá avances y mantené tu práctica en movimiento',
  status: 'gift'
}];
export function WhatYouGet() {
  return <Section id="incluye" data-id="element-193" data-mp="3sof59ptngq3q">
      <Reveal data-id="element-194" data-mp="1gb5r1o6kbfh">
        <SectionHeading title="Al inscribirte hoy obtenés" subtitle="Los 6 módulos completos + los 3 bonos de regalo, todo en un solo lugar con acceso inmediato." data-id="element-195" data-mp="1guafgotl3bk" />
      </Reveal>

      <Reveal index={1} data-id="element-196" data-mp="22jbz8b0fg92f">
        <p className="mt-8 text-center text-xs font-medium text-forest-700/50 md:hidden" data-id="element-197" data-mp="22isdej7np0j4">
          ← Deslizá para ver la tabla completa →
        </p>
        <div className="mt-4 overflow-x-auto rounded-2xl border border-sand-200 bg-white shadow-sm" data-id="element-198" data-mp="2bacc55canae3">
          <table className="w-full min-w-[560px] text-left" data-id="element-199" data-mp="26jcd9ujm6i8y">
            <thead data-id="element-200" data-mp="26hrji754j3c5">
              <tr className="border-b border-sand-200 bg-forest-50" data-id="element-201" data-mp="2l8rzqyc441iu">
                <th className="px-5 py-4 text-sm font-semibold text-forest-800" data-id="element-202" data-mp="2l6xhjrs86nig">Contenido</th>
                <th className="w-32 px-5 py-4 text-right text-sm font-semibold text-forest-800" data-id="element-203" data-mp="2g9ffmlcml8jy">
                  Estado
                </th>
              </tr>
            </thead>
            <tbody data-id="element-204" data-mp="2q969cktd3jiz">
              {rows.map((r, i) => <tr key={r.content} className={i % 2 === 1 ? 'bg-sand-50/60' : 'bg-white'} data-id="element-205" data-mp="zv5oxkkwv7py" data-mpi={i}>
                  <td className="px-5 py-4 align-top" data-id="element-206" data-mp="vvesp1cm7ze1">
                    <div className="flex items-start gap-3" data-id="element-207" data-mp="lq5cboqrsp0j">
                      <span className="text-lg leading-none" aria-hidden data-id="element-208" data-mp="ls02bhgwf7bh">
                        {r.emoji}
                      </span>
                      <span className="text-sm leading-relaxed text-forest-700/85" data-id="element-209" data-mp="c0c6z5h8164q">
                        {r.content}
                      </span>
                    </div>
                  </td>
                  <td className="px-5 py-4 text-right align-top" data-id="element-210" data-mp="2262qh7xznwp">
                    {r.status === 'included' ? <span className="inline-flex whitespace-nowrap rounded-full bg-forest-500/10 px-3 py-1 text-xs font-semibold text-forest-600" data-id="element-211" data-mp="7198y4zns069">
                        ✅ Incluido
                      </span> : <span className="inline-flex whitespace-nowrap rounded-full bg-clay-400/15 px-3 py-1 text-xs font-semibold text-clay-600" data-id="element-212" data-mp="3u5yv6a8kqckr">
                        🎁 Regalo
                      </span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Reveal>
    </Section>;
}